var map = {
	"./add-image.svg": 432,
	"./angle-arrow-down.svg": 78,
	"./arrows.png": 23,
	"./btn-background.png": 24,
	"./button-down.png": 433,
	"./button-up.png": 434,
	"./chosen-balls-background.png": 30,
	"./coins.png": 435,
	"./delete-purple.png": 15,
	"./delete-white.png": 13,
	"./dog-racing.png": 204,
	"./fast-betting-btn-purple.png": 4,
	"./fast-betting-btn.png": 1,
	"./fast-btn-down.png": 8,
	"./fast-btn-up.png": 9,
	"./fast-coin.png": 436,
	"./fast-ticket-bck.png": 42,
	"./fullscreen.svg": 437,
	"./game-holder-bar.png": 438,
	"./green-btn-background.png": 439,
	"./grey-bck.png": 21,
	"./header-fast.png": 25,
	"./horse-racing.png": 205,
	"./hr-blue-btn.png": 3,
	"./hr-disabled-btn.png": 10,
	"./hr-grey-btn.png": 2,
	"./hr-red-btn.png": 20,
	"./log-in.png": 440,
	"./lucky-balls.png": 441,
	"./lucky-greek.png": 442,
	"./menu-active-background.png": 443,
	"./menu-right.svg": 444,
	"./red-btn-background.png": 14,
	"./rubbish-blue.svg": 445,
	"./rubbish-red-blue.svg": 446,
	"./rubbish-red.svg": 447,
	"./rubbish.svg": 448,
	"./send-message.svg": 449,
	"./share.svg": 450,
	"./slip-arrow-down.png": 451,
	"./slip-arrow-up.png": 452,
	"./ticket-background-light.png": 453,
	"./ticket-background.png": 454,
	"./tutorial-arrow-left.png": 455,
	"./tutorial-arrow-right.png": 456,
	"./up-arrow.svg": 79,
	"./video-roulette.png": 457,
	"./virtual-football-league.png": 458,
	"./virtual-football.png": 459
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46;


//////////////////
// WEBPACK FOOTER
// ./src/ui/img \.(gif|png|jpe?g|svg)$/
// module id = 46
// module chunks = 13